// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingGuaranteeTransactionListResponse

import { hydrateBillingGuaranteeTransaction, type BillingGuaranteeTransaction, type BillingGuaranteeTransactionApiResponse } from './billingGuaranteeTransaction.gen';

export type BillingGuaranteeTransactionListApiResponse = {
	items: BillingGuaranteeTransactionApiResponse[];
};

export type BillingGuaranteeTransactionList = {
	items: BillingGuaranteeTransaction[];
};

export function hydrateBillingGuaranteeTransactionList(data: BillingGuaranteeTransactionListApiResponse): BillingGuaranteeTransactionList {
	return {
		...data,
		items: data.items.map(hydrateBillingGuaranteeTransaction),
	};
}